<template>
    <div class="w-full overflow-hidden">
        <div id="hero-banner" class="relative" :class="headerHeight">
            <div
                class="flex items-center justify-center absolute inset-0 bg-no-repeat bg-center bg-cover"
                :style="{ backgroundImage: 'url(' + headerImageUrl + ')'}"
            >
                <div v-if="translated(title) || translated(subtitle)" class="absolute inset-0 bg-black opacity-25"></div>
            </div>
            <div class="absolute inset-0 site__container h-full">
                <div class="h-full w-full relative">

                    <div
                        class="flex h-full"
                        :class="[ titlePadding, titleXAligment, titleYAlignment, titleTextAlignment ]"
                    >
                        <div class="w-1/12 flex-none"></div>
                        <div
                            class="w-2/3 mb-72 flex-none text-white site__font--display leading-snug text-shadow"
                            :class="titleWidth"
                        >
                            <h1
                                class="font-semibold"
                                :class="[ titleSize, titleMargin ]"
                            >{{ translated(title) }}</h1>
                            <h2

                                :class="[ subtitleSize ]"
                            >{{ translated(subtitle) }}</h2>
                        </div>
                        <div class="w-1/12 flex-none"></div>
                    </div>

                    <div
                        class="absolute bottom-0 w-full flex h-48"
                        :class="socialAlignment"
                    >
                        <div
                            class="relative flex-none shadow-lg px-24 h-full flex items-center justify-center overflow-hidden site__color--brand-contrast site__rounded--small-top"
                            v-if="socials && Object.keys(socials).length"
                        >

                            <span
                                v-for="(value, key, index) in socials"
                                :key="index"
                                class="relative z-10"
                                :class="[ index === (Object.keys(socials).length - 1) ? '' : 'mr-16']"
                            >
                                <social-button :platform="key" :url="value"></social-button>
                            </span>

                            <div class="absolute inset-0 site__bg--brand opacity-85"></div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'pinia';
import {responsive } from '../../helpers';
import SocialButton from './SocialButton.vue';
import _pickBy from 'lodash/pickBy';
import { useCommonStore } from '../../state/common';
import { useBrandingStore } from '../../state/branding'

export default {
    components: {
        'social-button': SocialButton,
    },
    data: function () {
        return {
            alignX: 'center',
            alignY: 'center',
        }
    },
    computed: {
        ...mapState(useBrandingStore, ['preview']),
        ...mapState(useCommonStore, ['locale', 'currentCompany']),
        socials () {
            return _pickBy(this.currentCompany.social, value => value);
        },
        headerHeight () {
            //pt-60pct pt-40pct pt-30pct - needed for purge css
            return responsive(this.preview.type, 'pt-60pct sm:pt-40pct lg:pt-30pct')
        },
        titleWidth () {
            return responsive(this.preview.type, 'w-5/6 md:w-2/3');
        },
        titleMargin () {
            return responsive(this.preview.type, 'mb-8 md:mb-24');
        },
        titleSize () {
            return responsive(this.preview.type, 'text-heading-1 md:text-big');
        },
        subtitleSize () {
            return responsive(this.preview.type, 'text-body md:text-heading-1');
        },
        titlePadding () {
            return responsive(this.preview.type, 'pt-24 md:pt-48')
        },
        titleXAligment () {
            return responsive(this.preview.type, 'justify-center md:justify-' + this.alignX);
        },
        titleYAlignment () {
            return responsive(this.preview.type, 'items-center md:items-' + this.alignY);
        },
        titleTextAlignment () {

            let direction = {
                start: 'left',
                center: 'center',
                end: 'right'
            }[this.alignX];

            return responsive(this.preview.type, 'text-center md:text-' + direction)
        },
        socialAlignment () {
            return responsive(this.preview.type, 'justify-center md:justify-end');
        },
        title () {
            return this.currentCompany.jobsite.companypage_header1;
        },
        subtitle () {
            return this.currentCompany.jobsite.header_caption;
        },
        headerImageUrl () {
            return this.currentCompany.jobsite.header_url ? this.currentCompany.jobsite.header_url + '&w=2000&h=650&fit=max' : '/app/img/company_banner.png';
        },
    },
    mounted () {
        this.$emit('loaded');
    }
}
</script>
